module.exports = __webpack_public_path__ + "fonts/segoe_ui_bold-webfont.953d5bf.woff2";